import { Callout, Classes, Icon } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { ChatTimeline } from "@/components/pages_logged_in/roleplays/details/scenario/ChatTimeline";
import SessionRecording from "@/components/pages_logged_in/roleplays/details/scenario/SessionRecording";
import { LIGHT_GRAY, SUBTEXT_COLOR } from "@/css/constants";
import {
  RoleplaySessionTranscriptFragment,
  RoleplaySessionTranscriptQuery,
} from "@/graphql";

interface RoleplaySessionTranscriptProps {
  selectedMessage?: RoleplaySessionTranscriptFragment;
  onSelectMessage?: (message: RoleplaySessionTranscriptFragment) => void;
  currentTime: number;
  onTimeChange: (event: Event, duration: number) => void;
  onSelectTime: (time: number) => void;
  messagesData: RoleplaySessionTranscriptFragment[];
  isLoading: boolean;
  seekTime: number;
  duration: number;
  roleplaySession?: RoleplaySessionTranscriptQuery["roleplaySession"];
}

export function RoleplaySessionTranscript({
  selectedMessage,
  onSelectMessage = () => {},
  currentTime,
  onTimeChange,
  messagesData,
  isLoading,
  seekTime,
  duration,
  onSelectTime,
  roleplaySession,
}: RoleplaySessionTranscriptProps) {
  if (isLoading) {
    return <Box className={Classes.SKELETON} height={350} />;
  }

  if (!messagesData?.length) {
    return (
      <Callout
        intent="none"
        title={undefined}
        icon={<Icon icon="info-sign" color={SUBTEXT_COLOR} size={16} />}
        style={{
          marginBottom: 16,
          marginTop: 16,
          backgroundColor: LIGHT_GRAY,
          fontSize: 14,
        }}
      >
        <Box css={{ color: SUBTEXT_COLOR }}>
          The transcript is analyzing, Please wait...
        </Box>
      </Callout>
    );
  }

  if (!roleplaySession) {
    return null;
  }

  return (
    <Box css={{ position: "relative", marginBottom: 48 }}>
      <SessionRecording
        recordingUrl={roleplaySession?.recordingUrl ?? undefined}
        onTimeChange={onTimeChange}
        currentTime={currentTime}
        scenarioName={roleplaySession.scenario.name}
        user={roleplaySession.user}
      />
      <ChatTimeline
        messagesData={messagesData}
        selectedMessage={selectedMessage}
        onSelectedTime={onSelectTime}
        onSelectMessage={onSelectMessage}
        seekTime={seekTime}
        duration={duration}
        scenarioName={roleplaySession.scenario.name}
        user={roleplaySession.user}
      />
    </Box>
  );
}
